"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VendorStatusSummaryResponse = exports.HaulerWithAapTransportQuery = exports.HaulerSapContactUpdateFromWayste = exports.HaulerWithAapTransportToWaysteUpdate = exports.HaulerWithAapTransportToWayste = exports.HaulerSapContactTransportToWayste = exports.HaulerWithAapDataUpdate = exports.HaulerWithAapTransport = exports.HaulerSapContactUpdate = exports.HaulerSapContactCreate = exports.HaulerSapContactTransport = exports.HaulerContact = exports.VendorNameMapTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const nullable_1 = require("../common/nullable");
const hauler_sap_contact_pricing_zone_1 = require("./hauler-sap-contact-pricing-zone");
const hauler_transport_1 = require("./hauler-transport");
const hauler_vendor_1 = require("./hauler-vendor");
const hours_of_operation_transport_1 = require("./hours-of-operation-transport");
exports.VendorNameMapTransport = typebox_1.Type.Record(typebox_1.Type.String({ format: 'uuid' }), typebox_1.Type.String());
exports.HaulerContact = typebox_1.Type.Object({
    department: typebox_1.Type.Optional(typebox_1.Type.String()),
    email: typebox_1.Type.Optional(typebox_1.Type.String()),
    firstName: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastName: typebox_1.Type.Optional(typebox_1.Type.String()),
    phoneNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    notes: typebox_1.Type.Optional(typebox_1.Type.String()),
    sendBillingEmails: typebox_1.Type.Boolean(),
    sendDispatchEmails: typebox_1.Type.Boolean(),
    sendMarketingEmails: typebox_1.Type.Boolean(),
    sendRFPEmails: typebox_1.Type.Boolean(),
    primaryContact: typebox_1.Type.Boolean(),
});
exports.HaulerSapContactTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    haulerId: typebox_1.Type.String(),
    email: typebox_1.Type.Optional(typebox_1.Type.String()),
    firstName: typebox_1.Type.String(),
    lastName: typebox_1.Type.Optional(typebox_1.Type.String()),
    phoneNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    notes: typebox_1.Type.Optional(typebox_1.Type.String()),
    sendBillingEmails: typebox_1.Type.Boolean(),
    sendDispatchEmails: typebox_1.Type.Boolean(),
    sendMarketingEmails: typebox_1.Type.Boolean(),
    sendRFPEmails: typebox_1.Type.Boolean(),
    primaryContact: typebox_1.Type.Boolean(),
    pricingZones: typebox_1.Type.Array(hauler_sap_contact_pricing_zone_1.HaulerSapContactPricingZoneTransport),
    deletedAt: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String({ format: 'date-time' }))),
    metadata: common_1.MetaData,
});
exports.HaulerSapContactCreate = typebox_1.Type.Omit(exports.HaulerSapContactTransport, [
    'id',
    'metadata',
    'deletedAt',
    'pricingZones',
]);
exports.HaulerSapContactUpdate = typebox_1.Type.Partial(typebox_1.Type.Omit(exports.HaulerSapContactTransport, ['id', 'metadata', 'deletedAt', 'haulerId', 'pricingZones']));
exports.HaulerWithAapTransport = typebox_1.Type.Intersect([
    // Shared with Haulers table
    typebox_1.Type.Pick(hauler_transport_1.HaulerTransport, [
        'isSourgumPartner',
        'licences',
        'ein',
        'billingAddress',
        'yards',
        'website',
        'dumpsterSizes',
        'materials',
        'waysteLite',
        'sourgumVendorNumber',
        'timeZone',
        'vendorStatus',
    ]),
    // Specific to AAP
    typebox_1.Type.Object({
        id: typebox_1.Type.String(),
        waysteHaulerId: typebox_1.Type.String(), // This is haulerId in HaulerAapData entity. It's the Hauler table id.
        notes: typebox_1.Type.String(),
        billingAgentNotes: typebox_1.Type.Optional(typebox_1.Type.String()),
        active: typebox_1.Type.Boolean(),
        contacts: typebox_1.Type.Array(exports.HaulerSapContactTransport),
        name: typebox_1.Type.String(),
        defaultRentPeriod: typebox_1.Type.Optional(common_1.Duration),
        waysteRentalPeriod: typebox_1.Type.Optional(common_1.Duration),
        rentExtensionFee: typebox_1.Type.Optional(typebox_1.Type.Number()),
        waysteRentalExtensionFee: typebox_1.Type.Optional(typebox_1.Type.Number()),
        rating: typebox_1.Type.Optional(typebox_1.Type.Number()),
        hoursOfOperation: hours_of_operation_transport_1.HoursOfOperationTransport,
        defaultPaymentMethod: typebox_1.Type.Optional((0, nullable_1.Nullable)(common_1.PaymentMethod)),
        defaultPaymentTerm: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Integer({ minimum: 0 }))),
        vendorCreditLimit: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Integer({ minimum: 0 }))),
        rollOffDumpsters: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Integer({ minimum: 0 }))),
        commercialContainers: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Integer({ minimum: 0 }))),
        roTrucks: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Integer({ minimum: 0 }))),
        flTrucks: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Integer({ minimum: 0 }))),
        rlTrucks: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Integer({ minimum: 0 }))),
        numberOfDrivers: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Integer({ minimum: 0 }))),
        dotNumber: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
        invoicePlatform: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
        files: typebox_1.Type.Optional(typebox_1.Type.Array(common_1.S3ItemReference)),
        metadata: typebox_1.Type.Object({
            createdAt: typebox_1.Type.String(),
            createdByUserID: typebox_1.Type.String(),
            lastUpdatedAt: typebox_1.Type.String(),
            lastUpdatedByUserID: typebox_1.Type.String(),
        }),
    }),
]);
exports.HaulerWithAapDataUpdate = typebox_1.Type.Intersect([
    // `active` is derived from vendorStatus (+ onboarding grace window); clients should write vendorStatus instead.
    typebox_1.Type.Partial(typebox_1.Type.Omit(exports.HaulerWithAapTransport, ['id', 'contacts', 'active'])),
    typebox_1.Type.Object({
        // Optional lat/lng for the primary yard, used only on vendor creation
        primaryYardLatitude: typebox_1.Type.Optional(typebox_1.Type.Number()),
        primaryYardLongitude: typebox_1.Type.Optional(typebox_1.Type.Number()),
    }),
]);
exports.HaulerSapContactTransportToWayste = typebox_1.Type.Omit(exports.HaulerSapContactTransport, [
    'notes',
    'metadata',
    'haulerId',
    'pricingZones',
]);
exports.HaulerWithAapTransportToWayste = typebox_1.Type.Intersect([
    typebox_1.Type.Pick(exports.HaulerWithAapTransport, [
        'waysteHaulerId',
        'sourgumVendorNumber',
        'defaultPaymentMethod',
        'defaultPaymentTerm',
        'hoursOfOperation',
    ]),
    typebox_1.Type.Object({
        files: typebox_1.Type.Optional(typebox_1.Type.Array(common_1.PreSignedS3Object)),
        contacts: typebox_1.Type.Array(exports.HaulerSapContactTransportToWayste),
    }),
]);
exports.HaulerWithAapTransportToWaysteUpdate = typebox_1.Type.Intersect([
    typebox_1.Type.Pick(exports.HaulerWithAapTransport, ['hoursOfOperation']),
]);
exports.HaulerSapContactUpdateFromWayste = typebox_1.Type.Partial(typebox_1.Type.Omit(exports.HaulerSapContactTransport, ['id', 'metadata', 'deletedAt', 'haulerId', 'notes']));
exports.HaulerWithAapTransportQuery = typebox_1.Type.Partial(typebox_1.Type.Object({
    haulerID: typebox_1.Type.String(), // Comma separated list of hauler IDs
    vendorStatus: hauler_vendor_1.HaulerVendorStatusSchema, // Filter by vendor status; omit to include all statuses
    offset: typebox_1.Type.Integer({ minimum: 0 }), // Pagination offset (default: 0)
    limit: typebox_1.Type.Integer({ minimum: 1, maximum: 1000 }), // Pagination limit (default: 100)
}));
// Response for GET /v2/vendor-profiles/summary
exports.VendorStatusSummaryResponse = typebox_1.Type.Object({
    byStatus: typebox_1.Type.Record(typebox_1.Type.String(), typebox_1.Type.Integer({ minimum: 0 })),
});
//# sourceMappingURL=hauler-with-aap-transport.js.map